import requests from "../agent";

const Proveedor = {
  getAll: () => requests.get("/Proveedores/GetProveedores"),
  getAllByFilter: (data) =>
    requests.post("Proveedores/GetProveedoresFiltro", data),
  activeOrInactive: (data) =>
    requests.put("Proveedores/ActivarDesactivarProveedor", data),
  create: (data) => requests.post("Proveedores/CreateProveedor", data),
  update: (data) => requests.put("Proveedores/UpdateProveedor", data),
  delete: (id) => requests.delete(`Proveedores/DeleteProveedor/${id}`),
  sendCode: (id) => requests.post(`Proveedores/SendCode/${id}`),
  newCode: (id) => requests.put(`Proveedores/NewCode/${id}`),
};

export default Proveedor;
